import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: "AIzaSyAilL9nJ8HxbsARFnwLQkRcN-rb0g-H5wg",
  authDomain: "salesguru-86316.firebaseapp.com",
  projectId: "salesguru-86316",
  storageBucket: "salesguru-86316.firebasestorage.app",
  messagingSenderId: "808622255984",
  appId: "1:808622255984:web:76809a019e7852dc6d29b5"
};

console.log('[Firebase] Initializing Firebase app with project:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistence to local (default) to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).then(() => {
  console.log('[Firebase] Auth persistence set to LOCAL');
}).catch((error) => {
  console.error('[Firebase] Error setting auth persistence:', error);
});

// Log current auth state
// auth.onAuthStateChanged((user) => {
//   console.log('[Firebase] Global auth state changed:', {
//     isLoggedIn: !!user,
//     email: user?.email || 'none',
//     uid: user?.uid || 'none',
//     timestamp: new Date().toISOString()
//   });
// });

export const remoteConfig = getRemoteConfig(app);

// Windows installer URL is served from Remote Config (WINDOWS_DOWNLOAD_URL) so a new
// installer can ship without redeploying the portal. The default below is the fallback
// when the fetch fails or the parameter is unset — a stale link beats a broken button.
export const WINDOWS_DOWNLOAD_URL_KEY = 'WINDOWS_DOWNLOAD_URL';
export const WINDOWS_DOWNLOAD_URL_FALLBACK =
  'https://d3dg1lmpu1jt4g.cloudfront.net/windows/ApexiaLabsSetup-3.6.0.exe';

remoteConfig.settings.minimumFetchIntervalMillis = 60 * 60 * 1000; // 1 hour
remoteConfig.defaultConfig = {
  [WINDOWS_DOWNLOAD_URL_KEY]: WINDOWS_DOWNLOAD_URL_FALLBACK,
};

console.log('[Firebase] Firebase initialized successfully');

export default app;